import { API } from "../../api.js";
import { $, esc, fmtMoney } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";

// ---------------------------------------------------------------- Global Footprint

async function renderGlobalFootprint(main, snap) {
  main.innerHTML = `
    <div class="sx">
      <header class="sx-header"><div><h2 class="sx-title">Where you operate ${helpIcon("footprint")}</h2>
        <p class="sx-sub">Month ${snap.month}. Every country with a real presence: revenue, tax, products sold there and the government agreements behind it. Each one's full detail is in Global Holdings.</p></div></header>
      <div id="footprint-content">Loading…</div>
    </div>`;
  const fp = await fetch(`${API}/global-footprint`).then((x) => x.json());
  const content = $("footprint-content");

  const summary = `
    <div class="plain-english-card" style="margin-bottom:20px;">
      You have a real presence in <strong>${fp.country_count} ${fp.country_count === 1 ? "country" : "countries"}</strong>, with
      ${fmtMoney(fp.total_committed_incentive_investment)} committed across finalized government incentive deals.
    </div>
  `;

  const cards = `<div class="fp-grid">` + fp.entries.map((e) => `
    <div class="sx-card fp-card">
      <div class="mc-share" aria-hidden="true"><i style="width:${Math.max(2, Math.min(100, e.revenue_share_pct || 0)).toFixed(1)}%"></i></div>
      <div style="display:flex; justify-content:space-between; width:100%; align-items:center;">
        <div style="font-family:var(--font-display); font-size:16px; font-weight:600;">
          ${esc(e.country)} ${e.is_hq ? `<span class="status-pill signed" style="margin-left:6px;">HQ</span>` : ""}
        </div>
        <div class="mono" style="font-size:14px;">${fmtMoney(e.estimated_revenue)}/mo <span style="color:var(--text-low); font-size:12px;">(${e.revenue_share_pct}% of total)</span></div>
      </div>
      <table class="ledger" style="width:100%;">
        <tr><td class="label">Local Currency</td><td class="mono">${esc(e.currency)}</td></tr>
        <tr><td class="label">Corporate Tax Rate</td><td class="mono">${e.tax_rate !== null && e.tax_rate !== undefined ? (e.tax_rate * 100).toFixed(1) + "%" : "—"}</td></tr>
        <tr><td class="label">Products Localized Here</td><td>${e.localized_products.length ? e.localized_products.map(esc).join(", ") : "None yet"}</td></tr>
      </table>
      ${e.government_deals.length ? `
        <div style="width:100%;">
          <div style="font-size:12px; color:var(--text-low); text-transform:uppercase; letter-spacing:0.05em; margin-bottom:6px;">Finalized Government Incentives</div>
          ${e.government_deals.map((d) => `
            <div style="font-size:13px; color:var(--text-mid); margin-bottom:4px;">
              <strong style="color:var(--brass);">${esc(d.incentive_type)}</strong> —
              ${d.incentive_type === "Cash Subsidy Grant" ? fmtMoney(d.incentive_value) : (d.incentive_value * 100).toFixed(1) + "%"}
              over ${d.incentive_months} months, ${fmtMoney(d.investment_required)} committed (finalized M${d.finalized_month})
            </div>
          `).join("")}
        </div>
      ` : e.is_hq ? "" : `<div style="font-size:12px; color:var(--text-low);">No government incentive deals here yet.</div>`}
      ${e.is_hq ? "" : `<button type="button" data-fp-open="${esc(e.country)}">Open in Global Holdings →</button>`}
    </div>
  `).join("") + `</div>`;

  const lonely = fp.country_count <= 1 ? `<div class="sx-empty"><div class="sx-empty-title">Only your home country so far</div>
    <p>Enter a second country to sell there: governments compete for your investment with tax holidays, grants and market access.</p>
    <button type="button" class="primary" data-fp-explore>Explore a country →</button></div>` : "";
  content.innerHTML = summary + lonely + cards;
  const ex = content.querySelector("[data-fp-explore]");
  if (ex) ex.addEventListener("click", () => window.ges && window.ges.showTab("government"));
  content.querySelectorAll("[data-fp-open]").forEach((b) => b.addEventListener("click", () => {
    window.__cpSelect = b.dataset.fpOpen;
    if (window.ges) window.ges.showTab("countries");
  }));
}

export { renderGlobalFootprint };
